/**
 * Created by lxhfight on 2017/11/16.
 * Email:
 * Description:
 */

/**
 * 對圖片進行判斷轉換成縮略圖位置或者小圖位置
 * @param path
 * @param isSmall
 */
import { msgHttpReg } from '@/tools/regex'
import nl2br from 'nl2br'
import EmojiConvertor from '@/tools/emoji'
import configs from '@/tools/configs'

export const smartImagePath = (path, isSmall = true, isOrigin = false) => {
  let imagePath = path
  if (!imagePath) {
    return null
  }

  if (!imagePath.startsWith('http')) {
    return imagePath
  }

  if (isOrigin) {
    return imagePath.replace('s3-ap-southeast-1.amazonaws.com/next.give543', 'd2hrw3sjxwwsb1.cloudfront.net')
  }

  let suffix = imagePath.substring(imagePath.lastIndexOf('.'))

  const type = isSmall ? '-small' : '-big'
  if ((!imagePath.includes('s3-ap-southeast-1.amazonaws.com') &&
       !imagePath.includes('api.give543.com')) ||
    imagePath.includes('zrockgive') ||
    imagePath.includes('request') ||
    imagePath.includes('/test/') ||
    (imagePath.includes('/avatar/') && type === '-big') ||
    (imagePath.includes('/chat/') && type === '-big') ||
    imagePath.includes('/video/') ||
    suffix === '.gif' ||
    suffix === '.mp4') {
    return imagePath.replace('s3-ap-southeast-1.amazonaws.com/next.give543', 'd2hrw3sjxwwsb1.cloudfront.net')
  }
  const index = imagePath.lastIndexOf('.')
  imagePath = `${imagePath.substring(0, index)}${type}${imagePath.substring(index)}`
  return imagePath.replace('s3-ap-southeast-1.amazonaws.com/next.give543', 'd2hrw3sjxwwsb1.cloudfront.net')
}

export const newestImagePath = (path, isSmall = true) => {
  let link = path
  if (!link) {
    return null
  }
  const type = isSmall ? '-small' : ''
  if (link.includes('s3-ap-southeast-1.amazonaws.com')) {
    const index = link.lastIndexOf('.')
    link = `${link.substring(0, index)}${type}${link.substring(index)}`
    return link.replace('s3-ap-southeast-1.amazonaws.com/next.give543', 'd2hrw3sjxwwsb1.cloudfront.net')
  }
  const index = link.lastIndexOf('.')
  return `${link.substring(0, index)}${type}${link.substring(index)}`
}

export const shortString = (str) => {
  if (typeof str !== 'string') {
    return '-'
  }
  if (str.length > 12) {
    return `${str.substr(0, 12)}...`
  }
  return str
}

export const queryString = (obj) => {
  if (!obj) {
    return null
  }
  let result = ''
  for (const param in obj) {
    let content = ''
    if (!obj[param] && obj[param] !== 0) {
      continue
    }
    if (Array.isArray(obj[param])) {
      if (obj[param].length === 0) {
        continue
      }
      content = obj[param].toString()
    } else {
      content = obj[param]
    }
    result += ((result) ? `&${param}=${content}` : `?${param}=${content}`)
  }
  return result
}

export const setDefaultStore = (code, storeAry, containAdr = false, fields = { code: 'code', address: 'address' }) => {
  const codeField = fields.code
  const addressField = fields.address
  const result = storeAry.find(item => item[codeField] === code)
  let area = ''
  let city = ''
  if (result) {
    const newAdr = result[addressField]
    area = newAdr.slice(0, 3)
    let leftAddress = newAdr.slice(3)
    let matchItem = leftAddress.match(/市|縣|鄉|鎮|區/)
    if (matchItem) {
      city = leftAddress.slice(0, matchItem.index + 1)
    }
  }
  const value = [area, area + '-' + city, (code === '無' || !code) ? '' : code]
  return containAdr ? value.concat(result[addressField]) : value
}

export const setDefaultPalmBox = (code, palmBoxAry) => {
  let result = {}
  let city = ''
  let dict = ''
  if (code) {
    result = palmBoxAry.find(item => item.EDCODE === code)
    city = result.CITYNAME
    dict = result.DICTNAME
  }
  return [city, dict, code]
}

let emojiConvertor = null

export const unifiedToFacebookEmoji = (text) => {
  if (!text) {
    return ''
  }
  if (emojiConvertor === null) {
    emojiConvertor = new EmojiConvertor()
    emojiConvertor.replace_mode = 'img'
    emojiConvertor.img_set = 'facebook'
    emojiConvertor.allow_native = true
    emojiConvertor.img_sets.facebook.path = 'https://d2hrw3sjxwwsb1.cloudfront.net/img/emoji-data/img-facebook-64/'
    emojiConvertor.img_sets.apple.path = 'https://d2hrw3sjxwwsb1.cloudfront.net/img/emoji-data/img-apple-64/'
  }

  return emojiConvertor.replace_unified(text)
}

export const parseHttpUrlContent = (content) => {
  let text = content.replace(msgHttpReg, '<span onclick="event.stopPropagation(); window.openLink(\'$1$2\');" target="_blank" style="color: #10AEFF;text-decoration: underline;">$1$2</span>')
  return unifiedToFacebookEmoji(text)
}

// 換行 + url解析
export const formatTextContent = (content) => {
  if (!content) {
    return ''
  }

  let text = nl2br(content)
  return parseHttpUrlContent(text)
}

const saveImage = (url, success, error) => {
  let canvas, context, imageDataUrl, imageData
  let img = new Image()
  img.crossOrigin = 'anonymous'
  img.onload = () => {
    canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    context = canvas.getContext('2d')
    context.drawImage(img, 0, 0)
    try {
      imageDataUrl = canvas.toDataURL('image/jpeg', 1.0)
      imageData = imageDataUrl.replace(/data:image\/jpeg;base64,/, '')
      // eslint-disable-next-line
      cordova.exec(
        success,
        error,
        'Canvas2ImagePlugin',
        'saveImageDataToLibrary',
        [imageData]
      )
    } catch (e) {
      console.log(e.message)
      error()
    }
  }
  img.src = url
}

export const saveImageToPhone = (url, success, error) => {
  // eslint-disable-next-line
  let permissions = cordova.plugins.permissions
  permissions.checkPermission(permissions.WRITE_EXTERNAL_STORAGE,
    (status) => {
      if (!status.hasPermission) {
        permissions.requestPermissions(
          [permissions.WRITE_EXTERNAL_STORAGE],
          (status) => {
            if (status.hasPermission) {
              saveImage(url, success, error)
            } else {
              error()
            }
          },
          error)
      } else {
        saveImage(url, success, error)
      }
    },
    error)
}

export const saveWebImage = (imgUrl) => {
  let frame = document.getElementById('download-iframe')
  if (!frame) {
    const body = document.getElementsByTagName('body')[0]
    frame = document.createElement('iframe')
    frame.style.display = 'none'
    frame.name = 'downloadIframe'
    frame.width = 0
    frame.height = 0
    frame.id = 'download-iframe'
    frame.addEventListener('load', () => {
      if (frame.src !== '' && frame.src !== 'about:blank') {
        window.frames['downloadIframe'].document.execCommand('SaveAs')
      }
    })
    body.appendChild(frame)
  }

  if (frame.src !== imgUrl) {
    frame.src = imgUrl
  } else {
    if (frame.src !== '' && frame.src !== 'about:blank') {
      window.frames['downloadIframe'].document.execCommand('SaveAs')
    }
  }
}

export const getStaticShareUrl = (type, objectId, query = '') => {
  if (['gift', 'need', 'story', 'lovebox', 'wish', 'festival'].includes(type)) {
    const subPath = {
      'gift': 'give',
      'need': 'want',
      'story': 'story',
      'lovebox': 'love'
    }[type] || type
    return `${configs.frontEndUrl}${subPath}/${objectId}${query ? '?' + query : ''}`
  } else if (['moment', 'wish', 'festival'].includes(type)) {
    return `${configs.frontEndUrl}share/${type}/${objectId}?${query}`
  } else {
    return ''
  }
}

export const getCommonwealPurchaseUrl = (needItemName, needId, needItemId, commonwealId, userId) => {
  return `${configs.momoSearchUrl}?searchKeyword=${needItemName}&needId=${needId}&needItemId=${needItemId}&doneeId=${commonwealId}&giveId=${userId}`
}
